import { Fragment, useMemo } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import { defaultGroupMessages } from "../../utils/groupMessages";
import { StyledMessageBubble } from "../styles";

import MessageLoaderItem from "./MessageLoaderItem";
import type { AgentChatThemeValue } from "./styles";
import type { MessagesListStrategyProps } from "./types";

type Props = MessagesListStrategyProps & {
    theme: AgentChatThemeValue;
};

const GroupedMessagesList = ({
    messages,
    renderMessage,
    uiContext,
    isLoading,
    theme,
    groupBy = defaultGroupMessages,
}: Props) => {
    const messageGroups = useMemo(() => groupBy(messages), [groupBy, messages]);

    const lastMessageGroupIndex = messageGroups.length - 1;

    return (
        <>
            {messageGroups.map((group, groupIndex) => {
                const isLastGroup = groupIndex === lastMessageGroupIndex;

                return (
                    <StyledMessageBubble key={groupIndex}>
                        <Stack gap={theme.msgBlockGapY}>
                            {group.messages.map((message, messageIndex) => {
                                const originalIndex = group.indices[messageIndex];
                                const isLastMessageInGroup = messageIndex === group.messages.length - 1;

                                const isLastMessageInSequence = isLastGroup && isLastMessageInGroup;
                                const isLoaderVisible = isLoading && isLastMessageInSequence;

                                return (
                                    <Fragment key={originalIndex}>
                                        {renderMessage(message, originalIndex, isLastMessageInSequence)}

                                        <MessageLoaderItem isVisible={isLoaderVisible}>
                                            {uiContext.loader}
                                        </MessageLoaderItem>
                                    </Fragment>
                                );
                            })}
                        </Stack>
                    </StyledMessageBubble>
                );
            })}
        </>
    );
};

export default GroupedMessagesList;
